import { useState } from 'react';
import styled from 'styled-components';

import { Box } from '@hivebrite/design-system/Box';

import Modal from 'hb-react/shared/components/DesignSystem/Modal';
import ThemeProvider from 'hb-react/style/ThemeProvider';

import ImageLibrary, { type ImageLibraryProps } from '../..';

export interface ImageLibraryModalProps extends ImageLibraryProps {
  onClose: () => void;
}

const ImageLibraryModal = ({
  features,
  initial,
  isPendingChecks,
  imageSize,
  networkId,
  onClose,
  onSave,
  onUpload,
}: ImageLibraryModalProps) => {
  const [title, setTitle] = useState<string>();

  return (
    <ThemeProvider theme="bo">
      <Modal
        dataTestId="image-library-modal"
        onCloseModal={onClose}
        screenReadersCloseButtonText={s__(
          'ImageLibraryModal|Close the image library',
        )}
      >
        {({ closeButton, labelledById }) => (
          <ModalContent>
            {closeButton}
            <Title id={labelledById}>{title}</Title>
            <ImageLibrary
              features={features}
              imageSize={imageSize}
              initial={initial}
              isPendingChecks={isPendingChecks}
              networkId={networkId}
              onSave={onSave}
              onUpload={onUpload}
              onClose={onClose}
              updateModalTitle={setTitle}
            />
          </ModalContent>
        )}
      </Modal>
    </ThemeProvider>
  );
};

export default ImageLibraryModal;

const ModalContent = styled(Box).attrs(() => ({
  bg: 'white',
  flexDirection: 'column',
  height: '843px',
  margin: '0 auto',
  maxWidth: '80vw',
  maxHeight: '80vh',
  width: '1261px',
}))`
  position: relative;
`;

const Title = styled(Box).attrs(() => ({
  font: 'h3-semibold',
  p: 5,
  width: '100%',
}))`
  box-shadow: 0px 0px 6px rgba(0, 0, 0, 0.1);
`;
